import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import MobileDownload from "./MobileDownload.vue";
import MobileUpload from "./MobileUpload.vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const title = document.title

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(title) === '123')
      ? (_openBlock(), _createBlock(MobileUpload, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(title) === '沁禾青果' || _unref(title) === '鮮食宅')
      ? (_openBlock(), _createBlock(MobileDownload, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})